import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { withBlockingRequest } from '../Application/withBlockingRequest.js'
import { ProjectLockedBlockerId } from './HandleProjectLockChangedEpic.js'

export const DeleteMultipleProjectSamplesEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.deleteMultipleProjectSamplesRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) =>
      withBlockingRequest(
        ProjectRepository.removeProjectSamples(action.payload.projectId, action.payload.projectSampleIds).pipe(
          mergeMap(() =>
            of(
              project.deleteMultipleProjectSamplesRequestSuccess(action.payload),
              project.loadProjectOrdersRequest({ projectId: action.payload.projectId })
            )
          ),
          catchError((error) => of(project.deleteMultipleProjectSamplesRequestFailure({ error })))
        ),
        'Removing samples',
        'Please wait, this operation may take longer depending on project size',
        ProjectLockedBlockerId(action.payload.projectId)
      )
    )
  )
